export const EVENT_MESSAGES = {
  CLIENT_READY: 'client_ready',
  CLIENT_POST_DATA: 'client_post_data',
  CLOSE_DIALOG: 'close_dialog',
};
